import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import Icon from '@space-core/components/icon'
import clsx from 'clsx'
import styled from 'styled-components'

export type SectionTypeTagProps = {
  label: string
  icon: IconDefinition
  className?: string
}

const Tag = styled.span`
  width: max-content;
  border: 0.063rem solid var(--white);
  background-color: rgba(14, 16, 18, 0.8);
`

const SectionTypeTag = ({ label, icon, className }: SectionTypeTagProps) => {
  return (
    <Tag className={clsx('_rounded _px-3 _py-2 _d-flex _align-items-center', className)}>
      <Icon icon={icon} aria-hidden className='_text-2 _text-white' />
      <p className='_text-1 _text-white _mb-0 _ml-2 _font-weight-bold'>{label}</p>
    </Tag>
  )
}

export default SectionTypeTag
